import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { signupTrackingFields } from '@/utils/signupTracking';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// The end-of-post signup — a real email form right where a reader finishes a
// story, instead of a button that sends them off to /subscribe first.
function PostSubscribeForm({ postPath }) {
  const [email, setEmail] = useState('');
  const [weekly, setWeekly] = useState(false);
  const [website, setWebsite] = useState(''); // honeypot — real visitors never see/fill this field
  const [loading, setLoading] = useState(false);
  const [doneMessage, setDoneMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      toast.error('Please enter a valid email address');
      return;
    }
    setLoading(true);
    try {
      const resp = await axios.post(`${BACKEND_URL}/api/subscribers`, {
        email: email.trim(),
        frequency: weekly ? 'weekly' : 'daily',
        website,
        ...signupTrackingFields('post_form', postPath),
      });
      const message = resp.data?.message || '';
      setDoneMessage(
        message === 'Already subscribed'
          ? "You're already following — thanks for being here!"
          : message === 'Frequency updated'
          ? (resp.data.frequency === 'daily'
            ? "You're all set to get every new story."
            : "You're all set to the weekly roundup.")
          : message.startsWith('Welcome back')
          ? "Welcome back! You're following again."
          : "You're in! Watch your inbox for the next story."
      );
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscribe-cta">
      <h3>Enjoy this story?</h3>
      {doneMessage ? (
        <p style={{ margin: 0 }} data-testid="post-subscribe-done">{doneMessage}</p>
      ) : (
        <>
          <p>Follow to get OBX photography stories delivered to your inbox. Free, unsubscribe anytime.</p>
          <form onSubmit={handleSubmit} style={{ maxWidth: '440px', margin: '0 auto' }}>
            <input
              type="text"
              name="website"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
            />
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                aria-label="Email address"
                style={{
                  flex: '1 1 220px', minWidth: 0, padding: '12px 14px', fontSize: '16px',
                  border: '1px solid #d0d0d0', borderRadius: '4px', boxSizing: 'border-box'
                }}
                data-testid="post-subscribe-email"
              />
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
                style={{ flex: '0 0 auto', opacity: loading ? 0.7 : 1 }}
                data-testid="subscribe-cta-btn"
              >
                {loading ? 'Following…' : 'Follow'}
              </button>
            </div>
            <label style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px', marginTop: '12px',
              fontSize: '14px', color: '#666', cursor: 'pointer'
            }}>
              <input type="checkbox" checked={weekly} onChange={(e) => setWeekly(e.target.checked)} />
              Send me a weekly digest instead of every post
            </label>
          </form>
        </>
      )}
    </div>
  );
}

export default PostSubscribeForm;
